import { Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CrossButton from "assets/Primary_white.svg";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import GiveFeedback, { ChildComponentHandles } from "components/features/Feedback/GiveFeedback";
import { useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { getLoggedInUserHltId } from "utils/CommonFunctions";
import { feedbackTypes, responseTypes } from "utils/Types";
import { fetchSuggestedPlansIdAsync, submitSuggestedPlansFeedbackAsync } from "./SuggestedPlans.slice";

function InvalidPlanButton(props: any) {
  const childRef = useRef<ChildComponentHandles>(null);
  const { id } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const innCode = useAppSelector((state: any) => state.app.innCode);

  const deleteHandler = async (input: any) => {
    childRef.current?.submitUserFeedback();
    const props = {
      feedbacks: [
        {
          cmsId: id,
          helpfulYN: "N",
          inncode: innCode
        }
      ]
    };

    const response = await dispatch(submitSuggestedPlansFeedbackAsync(props));

    if (response.payload.status < responseTypes.success_threshold) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: "Plan removed from suggestions",
          variant: "success"
        })
      );
    }
    await dispatch(fetchSuggestedPlansIdAsync({ innCode }));
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Suggestion is not useful">
        <Button
          accessType={accessTypes.delete}
          iconButton
          icon={CrossButton}
          height="34"
          sx={{ marginLeft: "auto" }}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      {open && (
        <DialogFormation
          openDialog={open}
          handleClose={() => setOpen(false)}
          title="Delete Suggested Plan"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button label="Cancel" variant="secondary" onClick={() => setOpen(false)} />
              <Button
                accessType={accessTypes.delete}
                variant="alert"
                label="Delete"
                onClick={deleteHandler}
                sx={{
                  backgroundColor: tokens.Icon.Feeback.Alert,
                  color: tokens.Text.General.Inverse,
                  "&:hover": { color: tokens.Icon.Feeback.Alert }
                }}
              />
            </div>
          }
        >
          <Typography variant="body1" color={tokens.Text.General.PrimaryHeadline} sx={{ marginTop: "10px" }}>
            <Box component="span" sx={{ color: tokens.Text.General.PrimaryHeadline, fontWeight: 600 }}>
              {" "}
              {props.name || props.title}
            </Box>{" "}
            will be deleted from your suggested Plans list.
          </Typography>
          <Box sx={{ marginTop: "24px" }}>
            <GiveFeedback
              ref={childRef}
              saveFormDataToRedux
              id={process.env.REACT_APP_FEEDBACK_TYPES_REMOVE_SUGGESTIONS}
              type={feedbackTypes.RemoveSuggestions}
              payloadData={{
                cmsPlanId: props.id,
                planTitle: props.name || props.title,
                innCode: innCode,
                templatePlanId: props.templatePlanId,
                planMemberType: props?.owners?.includes(getLoggedInUserHltId) ? "Owner" : "Member",
                suggestedPlanType: props.source
              }}
            />
          </Box>
        </DialogFormation>
      )}
    </>
  );
}

export default InvalidPlanButton;
